module.exports = __webpack_public_path__ + "img/5O.780d93e3.png";